'use strict';

const { queryFirst, addClass, removeClass } = require('../../domUtil');
const TULIP_OPTIONS = {
    integrationId: 'INTEGRATION_ID',
    useGeolocation: true,
    browserStorage: 'sessionStorage',
    imageUploadEnabled: true,
    fixedIntroPane: false,
    displayStyle: 'button',
    saveOpenState: true,
    buttonWidth: '50px',
    buttonHeight: '50px',
    businessName: 'Chat with a Stylist',
    businessIconUrl: 'https://scene7.lillypulitzer.com/is/content/sugartown/tulip_lilly_favicon',
    customColors: { brandColor: '0f0c0c', conversationColor: '151043', actionColor: '333333' },
    awayMode: {
        pooledConversations: { enabled: true, unresponsiveTime: 300, showChannelSwitchPrompt: true },
        assignedConversations: { enabled: true, unresponsiveTime: 600, showChannelSwitchPrompt: true }
    },
    customText: {
        'en-US': {
            prechatCaptureConfirmationText: 'We are connecting you to an associate. If you would like to end this conversation at any point, type 0.',
            awayModeMessageAssigned:
                'Hi {customerName}! It appears you are currently unable to chat with us.Please reach out to Customer Care or leave us a message with your phone number. A Boutique Advisor will get back to you as soon as possible.',
            awayModeMessagePooled: 'Hi {customerName}! It appears you are currently unable to chat with us. Please reach out to or leave us a message with your phone number. A Boutique Advisor will get back to you as soon as possible.'
        }
    },
    prechatCapture: {
        enabled: true,
        fields: [
            { type: 'email', name: 'email', label: 'prechatCaptureEmailLabel', placeholder: 'prechatCaptureEmailPlaceholder' },
            { type: 'text', name: 'name', label: 'prechatCaptureNameLabel', placeholder: 'prechatCaptureNamePlaceholder' }
        ]
    }
};

const APPOINTMENT_OPTIONS = {
    app_key: 'APP_KEY',
    defaultUI: true,
    embed: false,
    includePrivateAppointments: true,
    selectorOptions: {
        service_project: {
            title: 'Select an Appointment Type',
            description: 'Which appointment type would you like?',
            card_image: '{{[project]image_url}}',
            card_title: '{{[project]name}}',
            card_body: '{{[project]description}}',
            card_footer: '<i class="far fa-clock"></i> {{[project]availability.length}}',
            filters: {
                't_disabled': 0,
                't_private': 0
            }
        },
        store_project: {
            title: 'Select a Store',
            description: 'Choose a store from the following that you will be visiting for your appointment.',
            card_title: '[meta]t_store_name',
            card_body: `{{[meta]t_store_address}}, {{[meta]t_store_city}}`,
            card_footer: '[meta]t_store_phone',
            search_bar: {
                enabled: true,
                placeholder: 'Search for a City'
            },
            strategy: 'store_project'
        }
    }
};


/**
 * Tulip chat configuration function: moved from site preference chatConfig
 * @param {string} integrationID - Tulip integration ID preference value
 */
function initTulipChat(integrationID) {
    // Update integrationId wiht corect value from site preference
    TULIP_OPTIONS.integrationId = integrationID;
    const { tuliplivechat } = window;
    const stylistChatText = queryFirst('#stylist-chat-text');
    let messengerContainer = null;

    if (!tuliplivechat) return;

    tuliplivechat.init(TULIP_OPTIONS).then(() => {
        messengerContainer = queryFirst('#web-messenger-container');
        if (!tuliplivechat.isConversationActive()) {
            tuliplivechat.hideChatBubble();
            if (messengerContainer) addClass(messengerContainer, 'd-none');
        }
    });

    if (stylistChatText) {
        stylistChatText.addEventListener('click', () => {
            tuliplivechat.openChatWindow();
        });
    }

    tuliplivechat.on('widget:opened', () => {
        if (messengerContainer) removeClass(messengerContainer, 'd-none');
    });

    tuliplivechat.on('widget:closed', () => {
        const isChatActive = tuliplivechat.isConversationActive();
        tuliplivechat.showChatBubble(isChatActive);
        if (!isChatActive && messengerContainer) {
            addClass(messengerContainer, 'd-none');
        }
    });
}

/**
 * Tulip chat configuration function
 * @param {string} key - Tulip app_key ID preference value
 * @param {string} baseURL - Tulip api_base_url preference value
 */
function initAppointmentConfig(key, baseURL) {
    // Update integrationId wiht corect value from site preference
    APPOINTMENT_OPTIONS.app_key = key;
    if (baseURL && baseURL !== 'null') {
        APPOINTMENT_OPTIONS.api_base_url = baseURL;
    }
    window.timekit_project_selector.init(APPOINTMENT_OPTIONS).then(() => {
        addClass(queryFirst('#timekit-project-selector-container'), 'open');
        queryFirst('#timekit-header-right').onclick = function () {
            removeClass(queryFirst('#stylist-chat'), 'disable-click');
            if (queryFirst('#stylist-chat-text') !== null) {
                removeClass(queryFirst('#stylist-chat-text'), 'disable-click');
            }
            removeClass(queryFirst('#timekit-project-selector-container'), 'open');
            queryFirst('#floating-button').style.display = 'none';
        }
    }).catch((error) => {
    });
}

module.exports = {
    initTulipChat: initTulipChat,
    initAppointmentConfig: initAppointmentConfig
}
